import { useTranslation } from "../../../hooks/useTranslation";

export default function ShareBtn(props: { copyUrl: string }) {
  const { t } = useTranslation();

  const handleCopyClipBoard = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(props.copyUrl);
      alert("클립보드에 아티클 링크가 복사되었습니다.");
    } catch (err) {
      alert("복사를 실패하였습니다. 다시 시도해주세요.");
      console.log(err);
    }
  };

  return (
    <div className="share-btn-box" onClick={handleCopyClipBoard}>
      <img src="/assets/icons/FiLink.svg" />
      <div className="share-text">{t("contact.articleShare")} </div>
    </div>
  );
}
